import { forwardRef } from "react";

import { cn } from "@/lib/chillnn/cn";

import { Input } from "@/components/ui/input/input";

import { FormErrorMessage, FormItem, FormLabel } from "../../../_base/form";

import type { InputHTMLAttributes, ReactNode } from "react";

type Props = {
	type?: "text" | "email" | "tel"; // | 'search' | 'url'
	textAlign?: "left" | "center" | "right";

	className?: string;

	errorMessage?: string;
	label?: ReactNode;
} & InputHTMLAttributes<HTMLInputElement>;

/**
 * テキスト入力フィールドコンポーネント
 */
export const InputTextFieldNew = forwardRef<HTMLInputElement, Props>(
	({ type = "text", className = "", errorMessage, label, textAlign, ...props }: Props, ref) => {
		const textAlignStyle =
			textAlign === "center" ? "text-center" : textAlign === "right" ? "text-right" : "text-left";

		return (
			<FormItem className={className}>
				<FormLabel>{label}</FormLabel>
				<Input type={type} className={cn(textAlignStyle, "min-w-[110px]")} {...props} ref={ref} />
				<FormErrorMessage>{errorMessage}</FormErrorMessage>
			</FormItem>
		);
	},
);
